/* eslint-disable */
export default {
  ok: '확인',
} as const;

// @key: @#@"ok"@#@ @source: @#@"OK"@#@
